import widgetModule, { linkListStyles } from "@stoneage/Overrides/Widgets/Basic/SocialLinks";
import color from "@stoneage/XDL/Utilities/color";
import { css } from "styled-components";

linkListStyles.link = {
    typographyProps: {
        color: "text.main",
    },
    color: "common.white",
    css: css`
        &:hover,
        &:focus {
            svg {
                color: ${color("primary.main")};
            }
        }
        & rect {
            fill: ${color("common.white", 0.15)};
            stroke: unset;
        }
    `,
};

export * from "@stoneage/Overrides/Widgets/Basic/SocialLinks";
export default widgetModule;
